import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NotificationsService } from '../../../core/services/notifications.service';
import { fadeInUp, staggerIn } from '../../animations';

@Component({
  selector: 'app-notifications-panel',
  standalone: true,
  imports: [RouterLink, DatePipe],
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.component.css',
  animations: [fadeInUp, staggerIn]
})
export class NotificationsPanelComponent {
  @Input() open = false;
  @Output() closePanel = new EventEmitter<void>();

  readonly notificationsService = inject(NotificationsService);

  markAllRead(): void {
    this.notificationsService.markAllRead();
  }
}
